import React from "react"
import DashboardingPageView from "./Dashboarding.components/DashboardingPageView"
import './Dashboarding.components/DashboardingPageView.css'
import withAuthentication from "../../loaders/withAuthentication"

const Dashboarding = () => {
  // TODO: Ajouter un menu latéral et le routage vers d'autres vues plus tard
  return <DashboardingPageView />
}

export default withAuthentication(Dashboarding)